(() => {
    // const root = document.getElementById({{ slider_id | json }});
    // if (!root) return;

    document.querySelectorAll('[data-adev-reviews-slider]').forEach(root => {

        // Prevent double-init (Shopify editor can re-render)
        if (root.dataset.prsInited === '1') return;
        root.dataset.prsInited = '1';

        const track = root.querySelector('[data-prs-track]');
        if (!track) return;

        let slidesReal = Array.from(root.querySelectorAll('[data-prs-slide]'));
        if (slidesReal.length <= 1) return;

        const btnPrevAll = Array.from(root.querySelectorAll('[data-prs-prev]'));
        const btnNextAll = Array.from(root.querySelectorAll('[data-prs-next]'));
        const dotsWrap = root.querySelector('[data-prs-dots]');

        const autoplay = root.dataset.autoplay;
        const intervalMs = Math.max(2, root.dataset.autoplaySeconds * 1000);
        const equalizeReviewDescriptions = root.dataset.equalizeReviewDesc;

        let isPointerDown = false;
        let timer = null;

        const count = slidesReal.length;

        // ----- Infinite loop clones -----
        const cloneFirst = slidesReal[0].cloneNode(true);
        const cloneLast  = slidesReal[count - 1].cloneNode(true);

        cloneFirst.dataset.prsClone = '1';
        cloneLast.dataset.prsClone = '1';

        track.appendChild(cloneFirst);
        track.insertBefore(cloneLast, track.firstChild);

        // After cloning, rebuild list including clones
        const getSlidesAll = () => Array.from(track.querySelectorAll('[data-prs-slide]'));

        const getW = () => track.clientWidth || 1;

        // Start on the first REAL slide (indexAll = 1)
        const jumpToAllIndex = (indexAll) => {
        track.scrollLeft = indexAll * getW();
        };

        const getIndexAll = () => {
        return Math.round(track.scrollLeft / getW());
        };

        const toRealIndex = (indexAll) => {
        // indexAll: 0..count+1 ; 0=lastClone, count+1=firstClone
        // realIndex: 0..count-1
        return (indexAll - 1 + count) % count;
        };

        const goToReal = (realIndex, smooth = true) => {
        const idx = ((realIndex % count) + count) % count;
        track.scrollTo({ left: (idx + 1) * getW(), behavior: smooth ? 'smooth' : 'auto' });
        };

        const equalizeHeights = () => {
        if (!equalizeReviewDescriptions) return;

        const reviewTexts = slidesReal
            .map(slide => slide.querySelector('.prs-text'))
            .filter(Boolean);

        if (!reviewTexts.length) return;

        const removeReadMoreButtons = () => {
            root.querySelectorAll('.prs-read-more').forEach(button => button.remove());
        };

        removeReadMoreButtons();

        reviewTexts.forEach(el => {
            if (!el.dataset.prsOriginalText) {
            el.dataset.prsOriginalText = el.textContent.trim();
            }

            el.dataset.prsExpanded = 'false';
            el.textContent = el.dataset.prsOriginalText;
        });

        void root.offsetHeight;

        const measurements = reviewTexts
            .map(el => ({
            el,
            height: el.getBoundingClientRect().height
            }))
            .filter(item => item.height > 0);

        if (!measurements.length) return;

        const sortedHeights = measurements
            .map(item => item.height)
            .sort((a, b) => a - b);

        const targetHeight =
            sortedHeights.length >= 2
            ? sortedHeights[1]
            : sortedHeights[0];

        const tolerance = 1;

        const addReadMore = (el) => {
            if (el.nextElementSibling?.classList.contains('prs-read-more')) return;

            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'prs-read-more';
            button.textContent = 'Read more';
            button.setAttribute('aria-expanded', 'false');

            button.addEventListener('click', () => {
            const original = el.dataset.prsOriginalText || '';
            if (!original) return;

            el.textContent = original;
            el.dataset.prsExpanded = 'true';
            button.setAttribute('aria-expanded', 'true');
            button.remove();
            });

            el.insertAdjacentElement('afterend', button);
        };

        const truncateToHeight = (el, original, maxHeight) => {
            const words = original.split(/\s+/).filter(Boolean);
            if (words.length <= 1) return false;

            let low = 1;
            let high = words.length - 1;
            let best = 0;

            while (low <= high) {
            const mid = Math.floor((low + high) / 2);

            el.textContent =
                words.slice(0, mid).join(' ') + '...';

            if (el.getBoundingClientRect().height <= maxHeight + tolerance) {
                best = mid;
                low = mid + 1;
            } else {
                high = mid - 1;
            }
            }

            if (best > 0 && best < words.length) {
            el.textContent =
                words.slice(0, best).join(' ') + '...';
            el.dataset.prsExpanded = 'false';
            addReadMore(el);
            return true;
            }

            el.textContent = original;
            return false;
        };

        measurements.forEach(({ el, height }) => {
            const original = el.dataset.prsOriginalText || '';
            if (!original) return;

            if (height <= targetHeight + tolerance) {
            el.textContent = original;
            return;
            }

            truncateToHeight(el, original, targetHeight);
        });

        // Keep clone content in sync with the matching real slides.
        const allSlides = getSlidesAll();

        allSlides.forEach(slide => {
            if (!slide.dataset.prsClone) return;

            const cloneText = slide.querySelector('.prs-text');
            if (!cloneText) return;

            const cloneOriginal =
            cloneText.dataset.prsOriginalText ||
            cloneText.textContent.trim();

            const matchingReal = reviewTexts.find(realText =>
            (realText.dataset.prsOriginalText || '') === cloneOriginal
            );

            if (!matchingReal) return;

            cloneText.dataset.prsOriginalText =
            matchingReal.dataset.prsOriginalText || '';

            cloneText.dataset.prsExpanded = 'false';
            cloneText.textContent = matchingReal.textContent;

            const existingCloneButton =
            cloneText.nextElementSibling?.classList.contains('prs-read-more')
                ? cloneText.nextElementSibling
                : null;

            if (existingCloneButton) existingCloneButton.remove();

            if (
            matchingReal.nextElementSibling?.classList.contains('prs-read-more')
            ) {
            addReadMore(cloneText);
            }
        });
        };

        const collapseExpandedReviews = () => {
        if (!equalizeReviewDescriptions) return;

        const expanded = root.querySelectorAll(
            '.prs-text[data-prs-expanded="true"]'
        );

        if (!expanded.length) return;

        // Re-run the original truncation logic. This restores every expanded
        // review and adds "Read more" again only where needed.
        equalizeHeights();
        };

        const updateDots = () => {
        if (!dotsWrap) return;
        const real = toRealIndex(getIndexAll());
        dotsWrap.querySelectorAll('.prs-dot').forEach((d, i) => {
            d.classList.toggle('is-active', i === real);
        });
        };

        const buildDots = () => {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        for (let i = 0; i < count; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'prs-dot' + (i === 0 ? ' is-active' : '');
            b.setAttribute('aria-label', `Go to review ${i + 1}`);
            b.addEventListener('click', () => {
            stopAutoplay();
            collapseExpandedReviews();
            goToReal(i, true);
            });
            dotsWrap.appendChild(b);
        }
        };

        const next = () => {
        stopAutoplay();
        collapseExpandedReviews();
        const real = toRealIndex(getIndexAll());
        goToReal(real + 1, true);
        };

        const prev = () => {
        stopAutoplay();
        collapseExpandedReviews();
        const real = toRealIndex(getIndexAll());
        goToReal(real - 1, true);
        };

        const startAutoplay = () => {
        if (!autoplay) return;
        stopAutoplay();
        timer = setInterval(() => {
            if (isPointerDown) return;
            const real = toRealIndex(getIndexAll());
            goToReal(real + 1, true);
        }, intervalMs);
        };

        const stopAutoplay = () => {
        if (timer) clearInterval(timer);
        timer = null;
        };

        // Bind ALL arrow buttons (desktop + mobile)
        btnNextAll.forEach(btn => btn.addEventListener('click', next));
        btnPrevAll.forEach(btn => btn.addEventListener('click', prev));

        // Pause on interaction
        root.addEventListener('mouseenter', stopAutoplay);
        root.addEventListener('mouseleave', startAutoplay);
        track.addEventListener('pointerdown', () => { isPointerDown = true; stopAutoplay(); });
        window.addEventListener('pointerup', () => { isPointerDown = false; startAutoplay(); });

        // Fix position when landing on clones (the "infinite" trick)
        const normalizeIfOnClone = () => {
        const idxAll = getIndexAll();
        if (idxAll === 0) {
            // landed on lastClone -> jump to real last (indexAll = count)
            jumpToAllIndex(count);
        } else if (idxAll === count + 1) {
            // landed on firstClone -> jump to real first (indexAll = 1)
            jumpToAllIndex(1);
        }
        updateDots();
        };

        // Scroll listeners
        let raf = null;
        track.addEventListener('scroll', () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(updateDots);
        });

        // When scroll ends-ish, normalize clones
        let scrollEndTimer = null;
        track.addEventListener('scroll', () => {
        if (scrollEndTimer) clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(() => {
            collapseExpandedReviews();
            normalizeIfOnClone();
        }, 120);
        });

        // Re-equalize after images load
        const imgs = Array.from(root.querySelectorAll('.prs-avatar img'));
        imgs.forEach(img => {
        if (img.complete) return;
        img.addEventListener('load', () => requestAnimationFrame(equalizeHeights), { once: true });
        img.addEventListener('error', () => requestAnimationFrame(equalizeHeights), { once: true });
        });

        // Fonts (optional)
        if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => requestAnimationFrame(equalizeHeights));
        }

        window.addEventListener('resize', () => {
        const real = toRealIndex(getIndexAll());
        requestAnimationFrame(() => {
            goToReal(real, false);
            equalizeHeights();
            updateDots();
        });
        });

        // Init
        buildDots();

        // Jump to first real slide without animation
        requestAnimationFrame(() => {
        jumpToAllIndex(1);
        equalizeHeights();
        updateDots();
        requestAnimationFrame(equalizeHeights);
        startAutoplay();
        });

    });

})();